export default {
      id: "arrow_up-usage",
      viewBox: "0 0 8 5",
      url: __webpack_public_path__ + "img/icons.a12b6041.svg#arrow_up",
      toString: function () {
        return this.url;
      }
    }